/**
 * 用户交互链路埋点
 */
// import Crow from '@hb/crow';
// import UBT from './ubt';

// const crow = Crow({
//   send: (...args) => {
//     // eslint-disable-next-line no-console
//     console.log('Crow log', ...args);
//     UBT.send(...args);
//   },
//   getPageUrl: () => Promise.resolve(window.location.href),
// });

export default {
  send() {},
};
